import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, Table, Tooltip } from 'antd';
import Title from 'antd/es/typography/Title';
import * as _ from 'lodash';
import { getLimitedProcessApprove, getLimitedProcessApproveAdjustment, getLimitedProcessApproveVersion, getPreApprove } from './category-approve.reducer';
import { columnsPreApproval } from './config';

type IPreviousCategoryApproveProps = {
    isOpen: boolean;
    onClose: () => void;
    accountTableId: string;
    accountTableName: string;
    planPeriodId: string;
    selectedPeriod: number;
};

export const PreviousCategoryApproveComponent = React.memo(({ isOpen, onClose, accountTableId, accountTableName, planPeriodId, selectedPeriod }: IPreviousCategoryApproveProps) => {
    const dispatch = useAppDispatch();
    const data = useAppSelector(state => state.categoryApprove.preApprovals);
    const loading = useAppSelector(state => state.categoryApprove.loading);
    const account = useAppSelector(state => state.authentication.account);
    const [columns, setColumns] = useState([]);

    const columnsConfig = [{
        title: 'Hành động',
        key: 'action',
        width: 100,
        render(item: any) {
            if (item.ownerId)
                return (
                    <div className="action">
                        {item.documentId &&
                            <span className="action-view">
                                <Tooltip title="Xem chi tiết kết quả đánh giá mục tiêu/KR">
                                    <FontAwesomeIcon
                                        icon="eye"
                                    />
                                </Tooltip>
                            </span>
                        }
                        <span className="action-view">
                            <Tooltip title="Xem chi tiết kết quả đánh giá tổng hợp">
                                <FontAwesomeIcon
                                    icon="eye"
                                />
                            </Tooltip>
                        </span>
                    </div>
                )
        }
    }]

    useEffect(() => {
        handleGetPreApproval();
        handleGetProcessApproveLimited();
    }, [])


    const handleGetPreApproval = () => {
        dispatch(getPreApprove({ ownerId: accountTableId, planPeriodId: planPeriodId }))
    }

    const handleGetProcessApproveLimited = () => {
        if (selectedPeriod === 2) {
            dispatch(getLimitedProcessApproveVersion({ userId: account?.id, planPeriodId: planPeriodId })).then((res) => {
                if (res && res.payload) {
                    const result = (res.payload as any)?.data
                    if (result.length > 0) {
                        result.forEach(element => {
                            columnsPreApproval.push(
                                {
                                    title: `Cấp ${element}`,
                                    key: `cap_${element}`,
                                    render(item) {
                                        return (
                                            <span>{item?.workflowLevelStatusDynamic?.[`Cap_${element}`]?.name} {item?.workflowLevelStatusDynamic?.[`Cap_${element}`]?.statusName}</span>
                                        )
                                    },
                                },)
                        });
                    }
                }
                setColumns(_.uniqBy([...columnsPreApproval, ...columnsConfig], 'key'))
            });
        }
        if (selectedPeriod === 3) {
            dispatch(getLimitedProcessApproveAdjustment({ userId: account?.id, planPeriodId: planPeriodId })).then((res) => {
                if (res && res.payload) {
                    const result = (res.payload as any)?.data
                    if (result.length > 0) {
                        result.forEach(element => {
                            columnsPreApproval.push(
                                {
                                    title: `Cấp ${element}`,
                                    key: `cap_${element}`,
                                    render(item) {
                                        return (
                                            <span>{item?.workflowLevelStatusDynamic?.[`Cap_${element}`]?.name} {item?.workflowLevelStatusDynamic?.[`Cap_${element}`]?.statusName}</span>
                                        )
                                    },
                                },)
                        });
                    }
                }
                setColumns(_.uniqBy([...columnsPreApproval, ...columnsConfig], 'key'))
            });
        }

        return
    }


    const handleClose = () => {
        onClose();
    };


    return (
        <Modal open={isOpen} maskClosable={false} footer={null} onCancel={handleClose} width={'80vw'} className='view'>
            <div className="d-flex gap-5">
                <Title level={3}>Kết quả phê duyệt {accountTableName}</Title>
            </div>
            <div className="table">
                <Table scroll={{ y: '60vh' }} loading={loading} bordered dataSource={data.map((x: any, index) => {
                    return {
                        ...x,
                        key: index,
                    }
                })} pagination={false} columns={columns} />
            </div>
        </Modal>
    );
});

export default PreviousCategoryApproveComponent;
